import { Formik, Form } from "formik";
import { Spinner } from "react-bootstrap";

import Panel from "../../Panel";
import { Heading, Intro } from "../../Typography";
import PictureInput from "../../../../../components/PictureInput";
import {
  Field,
  Input,
  Label,
  SubmitButton,
} from "../../../../../components/forms";
import useJudgeConfirmScreen from "./useJudgeConfirmScreen";
import useLocation from "../../../../../hooks/useLocation";

const JudgeConfirmScreen = () => {
  const { profile, initialValues, onSubmit, schema, competition } =
    useJudgeConfirmScreen();

  const location = useLocation<{ didJustRegister: boolean }>();
  const didJustRegister = location.state?.didJustRegister || false;

  return (
    <Panel>
      <Heading>{profile ? `Welcome, ${profile.firstName}` : <br />}</Heading>
      <Intro>
        {!didJustRegister
          ? "Please check your account details and hit Start to proceed."
          : "Thanks, that’s everything we need to know!"}
      </Intro>
      {competition && profile ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={schema}
        >
          <Form>
            {!didJustRegister ? (
              <>
                <Field name="profilePicture" className="text-center">
                  <PictureInput />
                </Field>
                <Field name="firstName">
                  <Label>First name</Label>
                  <Input type="text" />
                </Field>
                <Field name="lastName">
                  <Label>Last name</Label>
                  <Input type="text" />
                </Field>
              </>
            ) : null}
            <SubmitButton>Start Judging</SubmitButton>
          </Form>
        </Formik>
      ) : (
        <Spinner animation="border" />
      )}
    </Panel>
  );
};

export default JudgeConfirmScreen;
